export class PanelHubConstants {

    public static readonly StandardFilterLength: number = 5;
     public static readonly MinSearchTextLength : number = 3;

    //Constants for empty results
    public static readonly NoResultStatus: string = 'info';
    public static readonly NoResultMessage: string = 'No result found';
    public static readonly NoResultDisplayButtons: boolean = false;
    public static readonly NoResultSubTitle: string = '';

    public static readonly SelectedMenuItemStyleClass : string = 'font-bold bg-black-alpha-10'
    public static readonly SelectedMenuItemIcon : string = 'fa fa-check';
    public static readonly EmptyString : string = ''
    public static readonly MenuItemBaseClass : string = 'p-menuitem-compact'

    public static readonly DefaultSortLabel : string = 'Sort By';
   
}
